import { OrganizationConfig } from '@tenants/types/tenant';
import { NEWHOMES_ROUTE } from 'components/dynamic-page/route-matchers';
import { CountryCodeList } from 'types/countries';
import { ZOOCASA_ADDRESS, EXP_CANADA_ADDRESS } from '@tenants/definitions/shared/addresses';
import type { Route } from 'components/dynamic-page/route-matchers/types';

export function createOrganizationConfig(): OrganizationConfig {
  return {
    phoneNumber(route?: Route) {
      return route === NEWHOMES_ROUTE ? '1-647-952-6657' : '1-844-683-4663';
    },
    email(route?: Route) {
      return route === NEWHOMES_ROUTE ? 'newhomes@zoocasa.com' : 'INFO@ZOOCASA.COM';
    },
    address(siteLocation?: CountryCodeList) {
      return siteLocation === CountryCodeList.UNITED_STATES ? EXP_CANADA_ADDRESS : ZOOCASA_ADDRESS;
    },
    twitterUrl: 'https://x.com/zoocasa',
    facebookUrl: 'https://www.facebook.com/Zoocasa/',
    instagramUrl: 'https://www.instagram.com/zoocasa/',
    linkedinUrl: 'https://www.linkedin.com/company/zoocasa-com/',
    youtubeUrl: 'https://www.youtube.com/zoocasa',
    joinSectionUrl: 'https://zoocasa.com/careers',
  };
}
